import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

import * as ApexCharts from 'apexcharts';

declare var require: any;
var Highcharts = require('highcharts/highmaps.js');
var USA = require('@highcharts/map-collection/countries/us/us-all.geo.json');

@Component({
	selector: 'app-deposits-overview',
	templateUrl: './deposits-overview.component.html',
	styleUrls: ['./deposits-overview.component.scss']
})
export class DepositsOverviewComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	@Input() selected_tab: any;
	@Input() stepper_stage: any;
	@Input() type: any;
	@Input() business_plan: any;
	@Input() selected_opportunity_period: any;
	@Output() stateChanged = new EventEmitter<any>();

	user_details: any;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		if (this.type == "Upside Opportunities") {
			this.ai_explainability_sections = this.upside_opportunity_ai_explainability_sections;
		} else if (this.type == "Retention Opportunities") {
			this.ai_explainability_sections = this.retention_opportunity_ai_explainability_sections;
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
		} else if (this.type == "New Prospects") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			this.ai_explainability_sections = this.deposit_ai_explainability_sections;
		} else if (this.type == "Non Customers") {
			this.ai_explainability_sections = this.non_customer_ai_explainability_sections;
		}

		this.getPageSummary();
	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
			return null;
		}
		if (num === 0) {
			return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
			k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
			c =
			k < 1
				? num.toFixed(0 + fixed)
				: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
			d = c < 0 ? c : Math.abs(c),
			e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

	page_summary_data: any;
	page_summary_data_loaded: boolean = false;
	getPageSummary() {
		this.page_summary_data_loaded = false;
		let route: any = "";
		if (this.type == "Bank Customers to Investment Clients") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/prospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=New" + "&opp_year=" + this.selected_opportunity_period;
      } else {
        route = "/prospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=New" + "&opp_year=" + this.selected_opportunity_period;
      }
		} else if (this.type == "New Prospects") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/magiprospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=New Prospect" + "&opp_year=" + this.selected_opportunity_period;
      } else {
        route = "/prospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=New Prospect" + "&opp_year=" + this.selected_opportunity_period;
      }
		} else if (this.type == "Bank Customers to Deposit Clients") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/magiprospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=members_magi" + "&opp_year=" + this.selected_opportunity_period;
      } else {
        route = "/prospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=members" + "&opp_year=" + this.selected_opportunity_period;
      }
		} else if (this.type == "Bank Customers to Lending Clients") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/magiprospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=lending_magi" + "&opp_year=" + this.selected_opportunity_period;
      } else {
        route = "/prospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=lending" + "&opp_year=" + this.selected_opportunity_period;
      }
		} else if (this.type == "Bank Customers to Insurance Clients") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/magiprospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=insurance_magi" + "&opp_year=" + this.selected_opportunity_period;
      } else {
        route = "/prospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=insurance" + "&opp_year=" + this.selected_opportunity_period;
      }
		} else if (this.type == "Non Customers") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/prospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=non_members" + "&opp_year=" + this.selected_opportunity_period;
      } else {
        route = "/prospectpreview/charts/" + "?business_plan_id=" + this.business_plan + "&prospect_type=non_members" + "&opp_year=" + this.selected_opportunity_period;
      }
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.page_summary_data = res["data"];

				if (this.show_graphical_representation == true) {

					setTimeout(() => {
						// if (this.type == "Institutional Customers to Deposit Clients") {
						// 	this.createBranchesGraph();
						// }
						this.createBranchesGraph();

            if (this.user_details.role.business_area[0] == 8){
              this.createLoanTypeGraph();
              this.createCrossSellProductsGraph();
              this.createProductMappingGraph();
            }
						this.createSourceComparisionGraph();
						this.createLeadsDurationGraph();
						this.createDemographicGraph();
						this.createIncomeRangeGraph();
						// this.getRegionGraph();
					}, 100);

				}

				this.getTableData();

				this.page_summary_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);

	}



	show_graphical_representation: boolean = true;
	toggleGraphs() {
		this.show_source_data = false;
		this.show_analysis = false;
		if (this.show_graphical_representation == true) {
			this.getPageSummary();
		}
	}

	show_source_data: boolean = false;
	toggleSourceData() {
		this.show_analysis = false;
		this.show_graphical_representation = false;
	}

	show_analysis: boolean = false;
	toggleAnalysis() {
		this.show_source_data = false;
		this.show_graphical_representation = false;
	}

	createBranchesGraph() {
		let $this = this;
		var options = {
			// colors: ["#D3D3D3", "#55A1EF"],
			colors: ['#1B82EC', '#FFA724', '#91C906'],
			series: $this.page_summary_data['leads_by_branches']['y-axis'],
			chart: {
				type: 'bar',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 300,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
				horizontal: false,
				columnWidth: $this.commonService.getBarGraphPercentWidth(
					document.getElementById('branches-graph').clientWidth,
					$this.page_summary_data['leads_by_branches']['x-axis'].length,
					15,
				),
				endingShape: 'rounded',
				},
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: $this.page_summary_data['leads_by_branches']['x-axis'],
				title: {
					text: '',
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				title: {
					text: 'Count',
				},
				labels: {
					// formatter: function (value) {
					// 	let val: any = Math.abs(value);
					// 	if (val >= 10 ** 3 && val < 10 ** 6) {
					// 		val = (val / 1000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'K';
					// 	} else if (val >= 10 ** 6) {
					// 		val = (val / 1000000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'M';
					// 	}
					// 	return val;
					// },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
					formatter: function (value) {
						// let val: string | number = Math.abs(value);
						// if (val >= 10 ** 3 && val < 10 ** 6) {
						// 	val = (val / 1000).toFixed(0) + 'K';
						// } else if (val >= 10 ** 6) {
						// 	val = (val / 1000000).toFixed(0) + 'M';
						// } else {
						// 	val = val;
						// }
						// return val;
						// return value.toLocaleString();
						return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
					},
				},
			},
		};

		var chart = new ApexCharts(document.querySelector('#branches-graph'), options);
		chart.render();
	}


  createLoanTypeGraph() {
    let $this = this;
        var options = {
        // colors: ["#5EDEC7"],
        series: [
          {
            name: '',
            data: $this.page_summary_data['opp_by_loan']['y-axis'],
          },
        ],
        chart: {
          type: 'bar',
          toolbar: {
          show: false,
          },
          zoom: {
          enabled: false,
          },
          height: 280,
        },
        noData: {
          text: 'No Data Available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
          },
        },
        plotOptions: {
          bar: {
          horizontal: false,
          columnWidth: $this.commonService.getBarGraphPercentWidth(
            document.getElementById('opp-loan-type-graph').clientWidth,
            $this.page_summary_data['opp_by_loan']['x-axis'].length,
            20,
          ),
          endingShape: 'rounded',
          // dataLabels: {
          //   position: 'bottom'
          // },
          },
        },
        dataLabels: {
          enabled: false,
          textAnchor: 'start',
          style: {
          colors: ['#000000'],
          fontWeight: '200',
          },
          formatter: function (val, opt) {
          return opt.w.globals.labels[opt.dataPointIndex];
          },
          offsetX: 0,
          dropShadow: {
          enabled: false,
          },
        },
        stroke: {
          show: true,
          width: 0,
          colors: ['transparent'],
        },
        xaxis: {
          categories: $this.page_summary_data['opp_by_loan']['x-axis'],
          title: {
          // text: 'Age Range'
          },
          crosshairs: {
          show: false,
          },
        },
        yaxis: {
          labels: {
            // formatter: function (value) {
            //   let val: any = Math.abs(value);
            //   if (val >= 10 ** 3 && val < 10 ** 6) {
            //     val = (val / 1000).toFixed(1);
            //     val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
            //     val += 'K';
            //   } else if (val >= 10 ** 6) {
            //     val = (val / 1000000).toFixed(1);
            //     val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
            //     val += 'M';
            //   }
            //   return val;
					  // },
            formatter: (value: number) => {
              return this.commonService.labelFormatter(value);
            }
				},
        },
        fill: {
          opacity: 1,
        },
			tooltip: {
				y: {
					formatter: function (value) {
						// let val: string | number = Math.abs(value);
						// if (val >= 10 ** 3 && val < 10 ** 6) {
						// 	val = (val / 1000).toFixed(0) + 'K';
						// } else if (val >= 10 ** 6) {
						// 	val = (val / 1000000).toFixed(0) + 'M';
						// } else {
						// 	val = val;
						// }
						// return val;
						// return value.toLocaleString();
						return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
					},
				},
			},

        };

        var chart = new ApexCharts(
        document.querySelector('#opp-loan-type-graph'),
        options,
        );
        chart.render();
  }

  createCrossSellProductsGraph() {
    let $this = this;
        var options = {
        // colors: ["#5EDEC7"],
        series: [
          {
            name: '',
            data: $this.page_summary_data['opp_by_products']['y-axis'],
          },
        ],
        chart: {
          type: 'bar',
          toolbar: {
          show: false,
          },
          zoom: {
          enabled: false,
          },
          height: 280,
        },
        noData: {
          text: 'No Data Available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
          },
        },
        plotOptions: {
          bar: {
          horizontal: false,
          columnWidth: $this.commonService.getBarGraphPercentWidth(
            document.getElementById('cross-sell-product-graph').clientWidth,
            $this.page_summary_data['opp_by_products']['x-axis'].length,
            20,
          ),
          endingShape: 'rounded',
          // dataLabels: {
          //   position: 'bottom'
          // },
          },
        },
        dataLabels: {
          enabled: false,
          textAnchor: 'start',
          style: {
          colors: ['#000000'],
          fontWeight: '200',
          },
          formatter: function (val, opt) {
          return opt.w.globals.labels[opt.dataPointIndex];
          },
          offsetX: 0,
          dropShadow: {
          enabled: false,
          },
        },
        stroke: {
          show: true,
          width: 0,
          colors: ['transparent'],
        },
        xaxis: {
          categories: $this.page_summary_data['opp_by_products']['x-axis'],
          title: {
          // text: 'Age Range'
          },
          crosshairs: {
          show: false,
          },
        },
        yaxis: {
          labels: {
            // formatter: function (value) {
            //   let val: any = Math.abs(value);
            //   if (val >= 10 ** 3 && val < 10 ** 6) {
            //     val = (val / 1000).toFixed(1);
            //     val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
            //     val += 'K';
            //   } else if (val >= 10 ** 6) {
            //     val = (val / 1000000).toFixed(1);
            //     val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
            //     val += 'M';
            //   }
            //   return val;
					  // },
            formatter: (value: number) => {
              return this.commonService.labelFormatter(value);
            }
				},
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (value) {
              // let val: string | number = Math.abs(value);
              // if (val >= 10 ** 3 && val < 10 ** 6) {
              // 	val = (val / 1000).toFixed(0) + 'K';
              // } else if (val >= 10 ** 6) {
              // 	val = (val / 1000000).toFixed(0) + 'M';
              // } else {
              // 	val = val;
              // }
              // return val;
              // return value.toLocaleString();
              return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
            },
          },
        },

        };

        var chart = new ApexCharts(
        document.querySelector('#cross-sell-product-graph'),
        options,
        );
        chart.render();
  }

  createProductMappingGraph() {
    let $this = this;
		var options = {
			// colors: ["#D3D3D3", "#55A1EF"],
			// colors: ['#1B82EC', '#FFA724', '#91C906'],
			colors: $this.page_summary_data['leads_product_mapping']['colors'],
			series: $this.page_summary_data['leads_product_mapping']['y-axis'],
			chart: {
				type: 'bar',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 300,
        // stacked: true,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
				horizontal: false,
				columnWidth: $this.commonService.getBarGraphPercentWidth(
					document.getElementById('product-mapping-graph').clientWidth,
					$this.page_summary_data['leads_product_mapping']['x-axis'].length,
					100,
				),
				endingShape: 'rounded',
				},
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: $this.page_summary_data['leads_product_mapping']['x-axis'],
				title: {
					text: '',
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				title: {
					text: 'Count',
				},
				labels: {
					// formatter: function (value) {
					// 	let val: any = Math.abs(value);
					// 	if (val >= 10 ** 3 && val < 10 ** 6) {
					// 		val = (val / 1000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'K';
					// 	} else if (val >= 10 ** 6) {
					// 		val = (val / 1000000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'M';
					// 	}
					// 	return val;
					// },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
					formatter: function (value) {
						// let val: string | number = Math.abs(value);
						// if (val >= 10 ** 3 && val < 10 ** 6) {
						// 	val = (val / 1000).toFixed(0) + 'K';
						// } else if (val >= 10 ** 6) {
						// 	val = (val / 1000000).toFixed(0) + 'M';
						// } else {
						// 	val = val;
						// }
						// return val;
						// return value.toLocaleString();
						return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
					},
				},
			},
		};

		var chart = new ApexCharts(document.querySelector('#product-mapping-graph'), options);
		chart.render();
  }

	createSourceComparisionGraph() {
		let $this = this;
		var options = {
			// colors: ["#D3D3D3", "#55A1EF"],
			colors: ['#1B82EC', '#FFA724', '#91C906'],
			series: $this.page_summary_data['leads_by_financialproducts']['y-axis'],
			chart: {
				type: 'bar',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 300,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
				horizontal: false,
				columnWidth: $this.commonService.getBarGraphPercentWidth(
					document.getElementById('source-comparision-graph').clientWidth,
					$this.page_summary_data['leads_by_financialproducts']['x-axis'].length,
					30,
				),
				endingShape: 'rounded',
				},
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: $this.page_summary_data['leads_by_financialproducts']['x-axis'],
				title: {
					text: '',
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				title: {
					text: 'Count',
				},
				labels: {
					// formatter: function (value) {
					// 	let val: any = Math.abs(value);
					// 	if (val >= 10 ** 3 && val < 10 ** 6) {
					// 		val = (val / 1000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'K';
					// 	} else if (val >= 10 ** 6) {
					// 		val = (val / 1000000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'M';
					// 	}
					// 	return val;
					// },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
					formatter: function (value) {
						// let val: string | number = Math.abs(value);
						// if (val >= 10 ** 3 && val < 10 ** 6) {
						// 	val = (val / 1000).toFixed(0) + 'K';
						// } else if (val >= 10 ** 6) {
						// 	val = (val / 1000000).toFixed(0) + 'M';
						// } else {
						// 	val = val;
						// }
						// return val;
						// return value.toLocaleString();
						return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
					},
				},
			},
		};

		var chart = new ApexCharts(document.querySelector('#source-comparision-graph'), options);
		chart.render();
	}

	leads_duration_filter: any = "Monthly";
	createLeadsDurationGraph() {
		let $this = this;

		let graph_data: any = [];
		let graph_labels: any = [];
		if ($this.leads_duration_filter == "Monthly") {
			graph_data = $this.page_summary_data['leads_by_months']['y-axis'];
			graph_labels = $this.page_summary_data['leads_by_months']['x-axis'];
		} else if ($this.leads_duration_filter == "Quarterly") {
			graph_data = $this.page_summary_data['leads_by_quarters']['y-axis'];
			graph_labels = $this.page_summary_data['leads_by_quarters']['x-axis'];
		} else if ($this.leads_duration_filter == "Yearly") {
			graph_data = $this.page_summary_data['leads_by_years']['y-axis'];
			graph_labels = $this.page_summary_data['leads_by_years']['x-axis'];
		}

		var options = {
			// colors: ["#D3D3D3", "#55A1EF"],
			colors: ['#1B82EC', '#FFA724', '#91C906'],
			series: graph_data,
			chart: {
				type: 'bar',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 300,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
				horizontal: false,
				columnWidth: $this.commonService.getBarGraphPercentWidth(
					document.getElementById('leads-duration-graph').clientWidth,
					graph_labels.length,
					30,
				),
				endingShape: 'rounded',
				},
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: graph_labels,
				title: {
					text: '',
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				title: {
					text: 'Count',
				},
				labels: {
					// formatter: function (value) {
					// 	let val: any = Math.abs(value);
					// 	if (val >= 10 ** 3 && val < 10 ** 6) {
					// 		val = (val / 1000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'K';
					// 	} else if (val >= 10 ** 6) {
					// 		val = (val / 1000000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'M';
					// 	}
					// 	return val;
					// },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
					formatter: function (value) {
						// let val: string | number = Math.abs(value);
						// if (val >= 10 ** 3 && val < 10 ** 6) {
						// 	val = (val / 1000).toFixed(0) + 'K';
						// } else if (val >= 10 ** 6) {
						// 	val = (val / 1000000).toFixed(0) + 'M';
						// } else {
						// 	val = val;
						// }
						// return val;
						// return value.toLocaleString();
						return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
					},
				},
			},
		};

		var chart = new ApexCharts(document.querySelector('#leads-duration-graph'), options);
		chart.render();
	}

	duration_grapH_loaded: boolean = true;
	durationGraphChange() {
		this.duration_grapH_loaded = false;
		setTimeout(() => {
			this.duration_grapH_loaded = true;
		}, 100);
		setTimeout(() => {
			this.createLeadsDurationGraph();
		}, 200);
	}

	createDemographicGraph() {
		let $this = this;
		var options = {
			// colors: ["#D3D3D3", "#55A1EF"],
			colors: ['#1B82EC', '#FFA724', '#91C906'],
			series: $this.page_summary_data['leads_by_segments']['y-axis'],
			chart: {
				type: 'bar',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 300,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
				horizontal: false,
				columnWidth: $this.commonService.getBarGraphPercentWidth(
					document.getElementById('demographic-segments-graph').clientWidth,
					$this.page_summary_data['leads_by_segments']['x-axis'].length,
					30,
				),
				endingShape: 'rounded',
				},
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: $this.page_summary_data['leads_by_segments']['x-axis'],
				title: {
					text: '',
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				title: {
					text: 'Count',
				},
				labels: {
					// formatter: function (value) {
					// 	let val: any = Math.abs(value);
					// 	if (val >= 10 ** 3 && val < 10 ** 6) {
					// 		val = (val / 1000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'K';
					// 	} else if (val >= 10 ** 6) {
					// 		val = (val / 1000000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'M';
					// 	}
					// 	return val;
					// },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
				},
			},
			fill: {
				opacity: 1,
			},
			// tooltip: {
			// 	y: {
			// 		formatter: function (value) {
			// 			// let val: string | number = Math.abs(value);
			// 			// if (val >= 10 ** 3 && val < 10 ** 6) {
			// 			// 	val = (val / 1000).toFixed(0) + 'K';
			// 			// } else if (val >= 10 ** 6) {
			// 			// 	val = (val / 1000000).toFixed(0) + 'M';
			// 			// } else {
			// 			// 	val = val;
			// 			// }
			// 			// return val;
			// 			// return value.toLocaleString();
			// 			return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
			// 		},
			// 	},
			// },
			tooltip: {
				// y: {
				//   formatter: function (val) {
				//     return val
				//   }
				// }
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					return (
						'<div style="width:250px; padding:8px">' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name</b>: ' +
						$this.page_summary_data['leads_by_segments']['x-axis'][dataPointIndex] +
						'</p>' +
						// '<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Age</b>: ' +
						// $this.page_summary_data['leads_by_segments']['conditions'][dataPointIndex] +
						// '</p>' +

						'<p><b>' + $this.page_summary_data['leads_by_segments']['y-axis'][seriesIndex]['name'] + '</b>: ' +
						($this.page_summary_data['leads_by_segments']['y-axis'][seriesIndex]['data'][dataPointIndex]).toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) +
						'</p>' +
						'</div>'
					);

				},
			}
		};

		var chart = new ApexCharts(document.querySelector('#demographic-segments-graph'), options);
		chart.render();
	}

	createIncomeRangeGraph() {
		let $this = this;
		var options = {
			// colors: ["#D3D3D3", "#55A1EF"],
			colors: ['#1B82EC', '#FFA724', '#91C906'],
			series: $this.page_summary_data['leads_by_income']['y-axis'],
			chart: {
				type: 'bar',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 300,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
				horizontal: false,
				columnWidth: $this.commonService.getBarGraphPercentWidth(
					document.getElementById('income-range-graph').clientWidth,
					$this.page_summary_data['leads_by_income']['x-axis'].length,
					30,
				),
				endingShape: 'rounded',
				},
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: $this.page_summary_data['leads_by_income']['x-axis'],
				title: {
					text: '',
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				title: {
					text: 'Count',
				},
				labels: {
					// formatter: function (value) {
					// 	let val: any = Math.abs(value);
					// 	if (val >= 10 ** 3 && val < 10 ** 6) {
					// 		val = (val / 1000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'K';
					// 	} else if (val >= 10 ** 6) {
					// 		val = (val / 1000000).toFixed(1);
					// 		val = val.endsWith('.0') ? val.slice(0, -2) : val; // Remove trailing '.0'
					// 		val += 'M';
					// 	}
					// 	return val;
					// },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
					formatter: function (value) {
						// let val: string | number = Math.abs(value);
						// if (val >= 10 ** 3 && val < 10 ** 6) {
						// 	val = (val / 1000).toFixed(0) + 'K';
						// } else if (val >= 10 ** 6) {
						// 	val = (val / 1000000).toFixed(0) + 'M';
						// } else {
						// 	val = val;
						// }
						// return val;
						// return value.toLocaleString();
						return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
					},
				},
			},
		};

		var chart = new ApexCharts(document.querySelector('#income-range-graph'), options);
		chart.render();
	}

	updateFlag = false;
	Highcharts: typeof Highcharts = Highcharts;
	chartConstructor = 'mapChart';
	chartOptions: Highcharts.Options = {
		chart: {
			map: USA,
		},
		exporting: {
			enabled: false,
		},
		title: {
			text: '',
		},
		subtitle: {
			text: '<a href="http://code.highcharts.com/mapdata/countries/us/us-all.js"></a>',
		},
		mapNavigation: {
			enabled: true,
			buttonOptions: {
				alignTo: 'spacingBox',
			},
		},
		legend: {
			enabled: true,
		},
		colorAxis: {
			min: 0,
		},
		series: [
			{
				type: 'map',
				states: {
					hover: {
						color: '#BADA55',
					},
				},
				dataLabels: {
					enabled: true,
					format: '{point.value}',
				},
				allAreas: false,
				data: [],
			},
		],
	};
	getRegionGraph() {
		let $this = this;
		$this.chartOptions.series[0] = {
		  type: 'map',
		  name: '',
		  states: {
			hover: {
				color: '#BADA55',
			},
		  },
		  dataLabels: {
			enabled: true,
			format: '{point.properties.postal-code}',
		  },
		  allAreas: false,
		  data: $this.page_summary_data['prospects_by_region'],
		};
		this.updateFlag = true;
	}

	selected_alphabet = '';
 	 alphabets_array = [ 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', ];
	current_pagination_page = 1;
	total_pagination_records = 0;
	pagination_records_limit: any = 10;
	show_search: boolean = false;
	search_key: any = "";
	table_columns: any = [];
	table_data: any = [];
	table_columns_data: any = [];
	selected_table_data: any = [];
	table_data_loaded: boolean = false;
	show_toggle_columns: boolean = false;

	getTableData() {
		this.table_data_loaded = false;

		let route: any = "";

		if (this.type == "Bank Customers to Investment Clients") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=New&source_data=true";
      } else {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=New&source_data=true";
      }
		} else if (this.type == "New Prospects") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=New Prospect&source_data=true";
      } else {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=New Prospect&source_data=true";
      }
		} else if (this.type == "Bank Customers to Deposit Clients") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=members&source_data=true";
      } else {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=members&source_data=true";
      }
		} else if (this.type == "Bank Customers to Lending Clients") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=lending_magi&source_data=true";
      } else {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=members&source_data=true";
      }
		} else if (this.type == "Bank Customers to Insurance Clients") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=insurance_magi&source_data=true";
      } else {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=members&source_data=true";
      }
		} else if (this.type == "Non Customers") {
			if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=non_members&source_data=true";
      } else {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;
			  route = route + "&prospect_type=non_members&source_data=true";
      }
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.table_columns = res["results"]['columns'];
				// for (let index = 0; index < this.table_columns.length; index++) {
				if (this.table_columns.length > 0) {
					for (let index = 0; index < 9; index++) {
						this.table_columns[index].checked = true;
					}
				}
				// this.table_data = res['results']['data'];
				this.table_data = res['results']['data'];
				this.current_pagination_page = res["page_number"];
				this.total_pagination_records = res["total_no_of_records"];
				this.table_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	getKey(data, column) {
		const key = column['key'];
		return data[key];
	}

	pageChanged(event) {
		this.selected_table_data = [];
		this.current_pagination_page = event;
		this.pagination_records_limit = this.pagination_records_limit;
		this.getTableData();
	}

	ai_explainability_sections: any = [];

	upside_opportunity_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "AI Rank",
					value: "Upside Opportunity is a crucial metric that helps identify the most promising clients for the company. This is a significant factor in the company's strategy for expanding its services. This rank is calculated by employing a sophisticated combination of two AI models: predicted opportunity and the shortest time to close the deal by the advisor. This AI model considers various client-specific attributes, historical transactions, advisor attributes, and macroeconomic variables. By analyzing these data points, the AI model can accurately assess the likelihood of a client churning."
				},
				{
					name: "AI recommendation",
					value: "Two additional AI models work in parallel to identify the optimal products and channels for the clients. These AI models help the advisor to recommend products through preferred channels. The AI model considers various client-specific attributes and historical transactions. By analyzing these data points, the AI model can accurately assess the optimal products and channels."
				},
				{
					name: "Opportunity",
					value: "The objective of this model is to predict the advisor's likelihood to sell. The input variables are demographic variables (client) and macroeconomic variables (market performance). This model works for existing clients as well as new clients (prospects). For the new clients the AUM, Balance, Net worth, Liquid net worth, and Count of products are not captured. These variables are not part of the final model. "
				},
				{
					name: "Shortest time to close",
					value: "This model estimates the shortest time to close the deal. Inputs to the model include customer demographics, transaction history, total investment, advisor experience, advisor certificates & licenses, and advisor states serviced. Relationships are identified between the independent and dependent variables using AI models. The model returns the days it takes to close the deal. "
				},
				{
					name: "Channel and Product",
					value: "Two additional AI models work in parallel to identify the optimal products and channels for the clients. These AI models help the advisor to recommend products through preferred channels. The AI model considers various client-specific attributes and historical transactions. "
				}
			]
		},
	];

	retention_opportunity_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "Risk Rank",
					value: "Attrition is a critical aspect of client management, and it involves a synergistic approach that combines both business rules and an advanced AI model. Together, these components collaboratively generate the risk rank for each client. Initially, the rule-based engine identifies clients who might be at risk of attrition based on predefined criteria and business rules."
				},
				{
					name: "Attrition Prediction",
					value: "After the rule-based engine identifies the at-risk clients, an AI model comes into play to calculate the probability of attrition for each identified client. The AI model considers various client-specific attributes and historical transactions. By analyzing these data points, the AI model can accurately assess the likelihood of a client churning."
				},
				{
					name: "Opportunity",
					value: "The objective of this model is to predict the advisor's likelihood to sell. The input variables are demographic variables (client) and macroeconomic variables (market performance). This model works for existing clients as well as new clients (prospects). For the new clients the AUM, Balance, Net worth, Liquid net worth, and Count of products are not captured. These variables are not part of the final model. "
				},
				{
					name: "Total Estimated Loss",
					value: "To understand the potential impact of attrition, the total estimated loss is calculated. This estimate is derived by summing up two key components: upside opportunities and the total value of invested aum. Upside opportunities involve identifying additional products or services that can be offered to existing clients. "
				}
			]
		},
	];

	leads_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "Opportunity",
					value: "New opportunity is a crucial metric that helps identify the most promising targets for the company. This is a significant factor in the company's strategy for expanding its services. This rank is calculated by employing a sophisticated combination of two AI models: AI rank and predicted wallet share"
				},
				{
					name: "AI Rank",
					value: "AI model comes into play to calculate the probability of successful sales for each identified target. The AI model considers various target-specific attributes, advisor attributes, and macroeconomic variables. By analyzing these data points, the AI model can accurately assess the likelihood of closing a deal."
				},
				{
					name: "Predicted Wallet Share",
					value: "This valuable metric is used to forecast the potential growth in the prospect's wallet share. It is calculated by utilizing the insights provided by the predicted opportunity along with the net worth of the prospect. This information aids the company in making data-driven decisions regarding resource allocation, targeted marketing strategies, and personalized offerings to enhance the prospect's overall engagement and satisfaction."
				}
			]
		},
	];

	deposit_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "Opportunity",
					value: "New opportunity is a crucial metric that helps identify the most promising targets for the company. This is a significant factor in the company's strategy for expanding its services. This rank is calculated by employing a sophisticated combination of two AI models: AI rank and predicted wallet share"
				},
				{
					name: "AI Rank",
					value: "AI model comes into play to calculate the probability of successful sales for each identified target. The AI model considers various target-specific attributes, advisor attributes, and macroeconomic variables. By analyzing these data points, the AI model can accurately assess the likelihood of closing a deal."
				},
				{
					name: "Predicted Wallet Share",
					value: "This valuable metric is used to forecast the potential growth in the prospect's wallet share. It is calculated by utilizing the insights provided by the predicted opportunity along with the net worth of the prospect. This information aids the company in making data-driven decisions regarding resource allocation, targeted marketing strategies, and personalized offerings to enhance the prospect's overall engagement and satisfaction."
				}
			]
		},
	];

	non_customer_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "Opportunity",
					value: "New opportunity is a crucial metric that helps identify the most promising targets for the company. This is a significant factor in the company's strategy for expanding its services. This rank is calculated by employing a sophisticated combination of two AI models: AI rank and predicted wallet share"
				},
				{
					name: "AI Rank",
					value: "AI model comes into play to calculate the probability of successful sales for each identified target. The AI model considers various target-specific attributes, advisor attributes, and macroeconomic variables. By analyzing these data points, the AI model can accurately assess the likelihood of closing a deal."
				},
				{
					name: "Predicted Wallet Share",
					value: "This valuable metric is used to forecast the potential growth in the prospect's wallet share. It is calculated by utilizing the insights provided by the predicted opportunity along with the net worth of the prospect. This information aids the company in making data-driven decisions regarding resource allocation, targeted marketing strategies, and personalized offerings to enhance the prospect's overall engagement and satisfaction."
				}
			]
		},
	];

	@ViewChild('clientDataModal') clientDataModal: TemplateRef<any>;
	private clientDataModalRef: MatDialogRef<TemplateRef<any>>;

	selected_modal_client: any;
	selected_modal_client_loader: boolean = false;;
	openClientDataModal(data) {
		this.selected_modal_client_loader = true;
		this.selected_modal_client = JSON.parse(JSON.stringify(data));


		this.clientDataModalRef = this.dialog.open(this.clientDataModal, { disableClose: true });
		this.clientDataModalRef.afterClosed().subscribe((result) => {
			this.closeClientDataModal();
		});

		// this.commonService.getData('/customerdetails/?id=' + this.selected_modal_client.id).subscribe(
		this.commonService.getData('/prospectdetails/?id=' + this.selected_modal_client.id).subscribe(
			(res: any) => {
				this.selected_modal_client = res["data"];
				this.selected_modal_client_loader = false;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	closeClientDataModal() {
		this.selected_modal_client = {};
		this.clientDataModalRef.close();
		this.selected_modal_client_loader = false;
	}

	show_user_profile: boolean = false;
    user_profile_data: any;
    showUserProfile(data) {
      this.user_profile_data = JSON.parse(JSON.stringify(data));
      this.show_user_profile = true;
    }

    profileClosed(event) {
      this.user_profile_data = {};
      this.show_user_profile = false;
    }

}
